module.exports = __webpack_public_path__ + "img/button_info_questionmark.926cc85f.svg";